/* tslint:disable */
/* eslint-disable */
/**
 * OpenAPI definition
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/**
 * Check if a given object implements the MonthYearDto interface.
 */
export function instanceOfMonthYearDto(value) {
    return true;
}
export function MonthYearDtoFromJSON(json) {
    return MonthYearDtoFromJSONTyped(json, false);
}
export function MonthYearDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'month': json['month'] == null ? undefined : json['month'],
        'year': json['year'] == null ? undefined : json['year'],
    };
}
export function MonthYearDtoToJSON(value) {
    if (value == null) {
        return value;
    }
    return {
        'month': value['month'],
        'year': value['year'],
    };
}
